import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import AsyncSelect from '../Common/AsyncSelect';
import UISpacer from '../UIComponents/UISpacer';
import { __ } from '@wordpress/i18n';
export default function MeetingSelector({ options, onChange, value, }) {
    const optionsWrapper = [
        {
            label: __('Meeting name', 'leadin'),
            options,
        },
    ];
    return (_jsxs(Fragment, { children: [_jsx(UISpacer, {}), _jsx("p", { "data-test-id": "leadin-meeting-select", children: _jsx("b", { children: __('Select a meeting scheduling page', 'leadin') }) }), _jsx(AsyncSelect, { defaultOptions: optionsWrapper, onChange: onChange, placeholder: __('Select a meeting', 'leadin'), value: value })] }));
}
